import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DOCUMENT_TYPE_CONFIG } from "./apiRoutes";

interface UseGetDocumentNumberRangesProps {
  documentTypeId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDocumentNumberRanges = async (documentTypeId: string) =>
  await axiosAuth.get(`${DOCUMENT_TYPE_CONFIG}/${documentTypeId}/number-ranges`);

const useGetDocumentNumberRanges = ({
  documentTypeId,
  queryParams,
}: UseGetDocumentNumberRangesProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["document-number-ranges", documentTypeId],
    queryFn: () => getDocumentNumberRanges(documentTypeId),
    select: (data: any) => {
      const payload = data?.data;
      if (Array.isArray(payload)) return payload;
      if (Array.isArray(payload?.data)) return payload.data;
      return [];
    },
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetDocumentNumberRanges;
